import { useEffect, useState, useCallback } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { API } from "@/App";
import { toast } from "sonner";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Badge } from "@/components/ui/badge";
import { Label } from "@/components/ui/label";
import {
  Plus,
  Search,
  Filter,
  MoreHorizontal,
  Eye,
  Edit,
  Trash2,
  ChevronLeft,
  ChevronRight,
  Download,
  RefreshCw,
  FileSearch,
  FileText,
  Clock,
  CheckCircle,
  XCircle,
  FilePlus2,
  History,
  ArrowRight,
  Calendar,
  Loader2,
  Phone,
  MessageCircle,
  Mail,
  Globe,
  Store,
  UserPlus,
  Megaphone,
  AlertCircle,
  Building2,
  Tag,
  Settings,
  ChevronDown,
  Check,
  X,
  Tags
} from "lucide-react";
import { Instagram, Facebook } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { cn } from "@/lib/utils";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { TimelineTagsModal } from "@/components/TimelineTagsModal";

const statusOptions = [
  { value: "all", label: "Todos os Status" },
  { value: "ATIVO", label: "Ativo" },
  { value: "INATIVO", label: "Inativo" },
  { value: "REPROVADO", label: "Reprovado" },
  { value: "BLOQUEADO", label: "Bloqueado" },
  { value: "EM PROSPECÇÃO", label: "Em Prospecção" },
];

const esteiraOptions = [
  { value: "all", label: "Todas as Etapas" },
  { value: "CAPTACAO", label: "Captação" },
  { value: "EM_SIMULACAO", label: "Em SIMULAÇÃO" },
  { value: "SEM_INTERESSE", label: "Sem Interesse" },
  { value: "MARGEM_NEGATIVA", label: "Margem Negativa" },
  { value: "COM_VALORES", label: "Com Valores" },
  { value: "SEM_VALORES", label: "Sem Valores" },
  { value: "PROPOSTA_EM_ANALISE", label: "Proposta Em Análise" },
  { value: "PROPOSTA_APROVADO", label: "Proposta Aprovado" },
  { value: "PROPOSTA_REPROVADO", label: "Proposta Reprovado" },
  { value: "FINALIZADO", label: "Finalizado" },
  { value: "DEPOSITO", label: "Depósito" },
];

const classificacaoOptions = [
  { value: "all", label: "Todas" },
  { value: "INTERNO", label: "Interno" },
  { value: "EXTERNO", label: "Externo" },
];

// Função para formatar CPF no padrão 000.111.222-33
const formatCPF = (cpf) => {
  if (!cpf) return "-";
  const numbers = cpf.replace(/\D/g, "");
  if (numbers.length !== 11) return cpf;
  return numbers.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
};

export default function ClientesList() {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const [clientes, setClientes] = useState([]);
  const [tagCounts, setTagCounts] = useState({});
  const [tagCountsTotal, setTagCountsTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(0);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [clienteToDelete, setClienteToDelete] = useState(null);
  
  // Modal de contratos do cliente
  const [showContratosModal, setShowContratosModal] = useState(false);
  const [clienteContratos, setClienteContratos] = useState(null);
  const [contratosDoCliente, setContratosDoCliente] = useState([]);
  const [loadingContratos, setLoadingContratos] = useState(false);

  // Modal de Linha do Tempo de Esteiras
  const [showTimelineModal, setShowTimelineModal] = useState(false);
  const [timelineCliente, setTimelineCliente] = useState(null);

  // Estados para gerenciamento de tags de clientes
  const [tagsClientes, setTagsClientes] = useState([]);
  const [filtroTagCliente, setFiltroTagCliente] = useState("TODAS");
  const [showConfigTagsClientes, setShowConfigTagsClientes] = useState(false);
  const [editandoTagCliente, setEditandoTagCliente] = useState(null);
  const [novaTagCliente, setNovaTagCliente] = useState({ nome: "", cor: "#3B82F6", bgCor: "#EFF6FF" });
  const [salvandoTagCliente, setSalvandoTagCliente] = useState(false);

  // Cores predefinidas para tags
  const CORES_TAGS = [
    { cor: "#3B82F6", bgCor: "#EFF6FF", nome: "Azul" },
    { cor: "#8B5CF6", bgCor: "#F5F3FF", nome: "Roxo" },
    { cor: "#10B981", bgCor: "#ECFDF5", nome: "Verde" },
    { cor: "#F59E0B", bgCor: "#FFFBEB", nome: "Amarelo" },
    { cor: "#EF4444", bgCor: "#FEF2F2", nome: "Vermelho" },
    { cor: "#06B6D4", bgCor: "#ECFEFF", nome: "Ciano" },
    { cor: "#EC4899", bgCor: "#FDF2F7", nome: "Rosa" },
    { cor: "#64748B", bgCor: "#F8FAFC", nome: "Cinza" },
  ];

  // Filters
  const [search, setSearch] = useState(searchParams.get("search") || "");
  const [status, setStatus] = useState(searchParams.get("status") || "all");
  const [esteira, setEsteira] = useState(searchParams.get("esteira") || "all");
  const [classificacao, setClassificacao] = useState(searchParams.get("classificacao") || "all");
  const [periodo, setPeriodo] = useState("hoje");
  const [page, setPage] = useState(parseInt(searchParams.get("page")) || 1);
  const perPage = 10;

  const fetchClientes = useCallback(async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      params.append("page", page.toString());
      params.append("per_page", perPage.toString());
      
      // MULTI-TENANCY: Adicionar empresa_id se disponível
      const empresaAtual = JSON.parse(localStorage.getItem("empresa") || "null");
      if (empresaAtual?.id) {
        params.append("empresa_id", empresaAtual.id);
      }
      
      if (search) params.append("search", search);
      if (status !== "all") params.append("status", status);
      if (esteira !== "all") params.append("esteira", esteira);
      if (classificacao !== "all") params.append("classificacao", classificacao);
      if (periodo !== "todos") params.append("periodo", periodo);
      if (filtroTagCliente !== "TODAS") params.append("tag_gestao_id", filtroTagCliente);

      const response = await axios.get(`${API}/clientes?${params.toString()}`);
      setClientes(response.data.clientes);
      setTotal(response.data.total);
    } catch (error) {
      console.error("Erro ao carregar clientes:", error);
      toast.error("Erro ao carregar clientes");
    } finally {
      setLoading(false);
    }
  }, [page, search, status, esteira, classificacao, periodo, filtroTagCliente]);

  const fetchTagCounts = useCallback(async () => {
    try {
      const empresaAtual = JSON.parse(localStorage.getItem("empresa") || "null");
      const params = new URLSearchParams();
      if (empresaAtual?.id) params.append("empresa_id", empresaAtual.id);
      if (search) params.append("search", search);
      if (status !== "all") params.append("status", status);
      if (esteira !== "all") params.append("esteira", esteira);
      if (classificacao !== "all") params.append("classificacao", classificacao);
      if (periodo !== "todos") params.append("periodo", periodo);
      const response = await axios.get(`${API}/clientes/tag-counts?${params.toString()}`);
      setTagCounts(response.data.counts || {});
      setTagCountsTotal(response.data.total || 0);
    } catch (error) {
      console.error("Erro ao carregar contagem de tags:", error);
    }
  }, [search, status, esteira, classificacao, periodo]);

  useEffect(() => {
    fetchClientes();
  }, [fetchClientes]);

  useEffect(() => {
    fetchTagCounts();
  }, [fetchTagCounts]);

  // Carregar tags de clientes
  useEffect(() => {
    const fetchTagsClientes = async () => {
      try {
        const response = await axios.get(`${API}/tags-gestao-clientes`);
        setTagsClientes(response.data || []);
      } catch (error) {
        console.error("Erro ao carregar tags:", error);
      }
    };
    fetchTagsClientes();
  }, []);

  // Contar clientes por tag
  const contadorPorTagCliente = clientes.reduce((acc, cliente) => {
    const tagId = cliente.tag_gestao_id || "SEM_TAG";
    acc[tagId] = (acc[tagId] || 0) + 1;
    return acc;
  }, {});

  // Filtro de tag agora é aplicado no backend (fetchClientes envia tag_gestao_id);
  // a tabela usa diretamente os clientes retornados.
  const clientesFiltradosPorTag = clientes;

  // Mudar tag do cliente
  const mudarTagCliente = async (clienteId, tagId) => {
    try {
      const usuarioData = localStorage.getItem("usuario");
      const usuario = usuarioData ? JSON.parse(usuarioData) : {};
      const operadorNome = usuario.nome || usuario.email || "";
      
      const res = await axios.patch(`${API}/clientes/${clienteId}/tag-gestao`, {
        tag_gestao_id: tagId,
        operador_nome: operadorNome
      });
      
      // Refletir a tag REALMENTE salva pelo backend (respeita a automação Captação->Qualificação)
      setClientes(prev => prev.map(c => {
        if (c.id === clienteId) {
          const fallback = tagsClientes.find(t => t.id === tagId);
          return {
            ...c,
            tag_gestao_id: res.data?.tag_gestao_id ?? tagId,
            tag_gestao_nome: res.data?.tag_gestao_nome ?? fallback?.nome
          };
        }
        return c;
      }));
      
      // Verificar se contrato foi criado automaticamente
      if (res.data?.contrato_criado) {
        const cc = res.data.contrato_criado;
        if (cc.status === "CRIADO") {
          toast.success(cc.mensagem, { duration: 5000 });
        } else if (cc.status === "LIMITE_ATINGIDO") {
          toast.warning(cc.mensagem, { duration: 5000 });
        }
      } else {
        toast.success("Tag atualizada!");
      }
      fetchTagCounts();
    } catch (error) {
      console.error("Erro ao atualizar tag:", error);
      toast.error("Erro ao atualizar tag");
    }
  };

  // Criar nova tag de cliente
  const criarTagCliente = async () => {
    if (!novaTagCliente.nome.trim()) {
      toast.error("Digite o nome da tag");
      return;
    }
    
    setSalvandoTagCliente(true);
    try {
      const res = await axios.post(`${API}/tags-gestao-clientes`, novaTagCliente);
      setTagsClientes(prev => [...prev, res.data]);
      setNovaTagCliente({ nome: "", cor: "#3B82F6", bgCor: "#EFF6FF" });
      toast.success("Tag criada com sucesso!");
    } catch (error) {
      console.error("Erro ao criar tag:", error);
      toast.error("Erro ao criar tag");
    } finally {
      setSalvandoTagCliente(false);
    }
  };

  // Atualizar tag de cliente
  const atualizarTagCliente = async () => {
    if (!editandoTagCliente?.nome.trim()) {
      toast.error("Digite o nome da tag");
      return;
    }
    
    setSalvandoTagCliente(true);
    try {
      const res = await axios.put(`${API}/tags-gestao-clientes/${editandoTagCliente.id}`, editandoTagCliente);
      setTagsClientes(prev => prev.map(t => t.id === editandoTagCliente.id ? res.data : t));
      setEditandoTagCliente(null);
      toast.success("Tag atualizada!");
    } catch (error) {
      console.error("Erro ao atualizar tag:", error);
      toast.error("Erro ao atualizar tag");
    } finally {
      setSalvandoTagCliente(false);
    }
  };

  // Migrar lead da Base para EXTERNO (cria cliente real)
  const migrarLeadParaExterno = async (lead) => {
    if (!window.confirm(`Migrar ${lead.nome} (lead da Base) para Externo? Isso vai criar um cliente novo no sistema.`)) return;
    try {
      const res = await axios.post(`${API}/leads-base/${lead.id}/migrar-para-externo`);
      toast.success(res.data?.message || "Lead migrado para Externo");
      await fetchClientes();
    } catch (err) {
      const msg = err?.response?.data?.detail || err.message || "Erro ao migrar lead";
      toast.error(msg);
    }
  };

  // Excluir tag de cliente
  const excluirTagCliente = async (tagId) => {
    if (!confirm("Tem certeza que deseja excluir esta tag? Os clientes serão movidos para outra tag.")) {
      return;
    }
    
    try {
      await axios.delete(`${API}/tags-gestao-clientes/${tagId}`);
      setTagsClientes(prev => prev.filter(t => t.id !== tagId));
      toast.success("Tag excluída!");
      fetchClientes();
    } catch (error) {
      console.error("Erro ao excluir tag:", error);
      toast.error("Erro ao excluir tag");
    }
  };

  useEffect(() => {
    const params = new URLSearchParams();
    if (search) params.set("search", search);
    if (status !== "all") params.set("status", status);
    if (esteira !== "all") params.set("esteira", esteira);
    if (classificacao !== "all") params.set("classificacao", classificacao);
    if (page > 1) params.set("page", page.toString());
    setSearchParams(params);
  }, [search, status, esteira, classificacao, page, setSearchParams]);

  const handleDelete = async () => {
    if (!clienteToDelete) return;
    
    try {
      await axios.delete(`${API}/clientes/${clienteToDelete.id}`);
      toast.success("Cliente excluído com sucesso");
      fetchClientes();
    } catch (error) {
      console.error("Erro ao excluir cliente:", error);
      toast.error("Erro ao excluir cliente");
    } finally {
      setDeleteDialogOpen(false);
      setClienteToDelete(null);
    }
  };

  const getStatusBadge = (cliente) => {
    const statusValue = cliente.acoes_operacionais?.status || "ATIVO";
    const statusColors = {
      ATIVO: "bg-green-100 text-green-800",
      INATIVO: "bg-red-100 text-red-800",
      REPROVADO: "bg-red-100 text-red-800",
      BLOQUEADO: "bg-gray-100 text-gray-800",
      "EM PROSPECÇÃO": "bg-yellow-100 text-yellow-800",
    };
    return (
      <Badge className={cn("font-medium", statusColors[statusValue] || "bg-gray-100 text-gray-800")}>
        {statusValue}
      </Badge>
    );
  };

  const getEsteiraBadge = (esteira) => {
    const esteiraColors = {
      CAPTACAO: "bg-blue-100 text-blue-800",
      EM_SIMULACAO: "bg-purple-100 text-purple-800",
      SEM_INTERESSE: "bg-slate-100 text-slate-800",
      MARGEM_NEGATIVA: "bg-red-100 text-red-800",
      COM_VALORES: "bg-emerald-100 text-emerald-800",
      SEM_VALORES: "bg-amber-100 text-amber-800",
      PROPOSTA_EM_ANALISE: "bg-orange-100 text-orange-800",
      PROPOSTA_APROVADO: "bg-green-100 text-green-800",
      PROPOSTA_REPROVADO: "bg-red-100 text-red-800",
      FINALIZADO: "bg-gray-100 text-gray-800",
      // Legados (compatibilidade)
      QUALIFICACAO: "bg-purple-100 text-purple-800",
      EM_ATENDIMENTO: "bg-purple-100 text-purple-800",
      ANALISE_DOCUMENTAL: "bg-orange-100 text-orange-800",
      APROVADO: "bg-green-100 text-green-800",
      RECUSADO: "bg-red-100 text-red-800",
      DEPOSITO: "bg-cyan-100 text-cyan-800",
    };
    return (
      <Badge variant="outline" className={cn("font-medium", esteiraColors[esteira] || "bg-gray-100")}>
        {esteira?.replace(/_/g, " ") || "N/A"}
      </Badge>
    );
  };

  // Cores e ícones das esteiras para a timeline
  const getEsteiraInfo = (esteira) => {
    const info = {
      CAPTACAO: { color: "bg-blue-500", borderColor: "border-blue-500", label: "Captação" },
      EM_SIMULACAO: { color: "bg-purple-500", borderColor: "border-purple-500", label: "Em Simulação" },
      SEM_INTERESSE: { color: "bg-slate-500", borderColor: "border-slate-500", label: "Sem Interesse" },
      MARGEM_NEGATIVA: { color: "bg-red-400", borderColor: "border-red-400", label: "Margem Negativa" },
      COM_VALORES: { color: "bg-emerald-500", borderColor: "border-emerald-500", label: "Com Valores" },
      SEM_VALORES: { color: "bg-amber-500", borderColor: "border-amber-500", label: "Sem Valores" },
      PROPOSTA_EM_ANALISE: { color: "bg-orange-500", borderColor: "border-orange-500", label: "Proposta Em Análise" },
      PROPOSTA_APROVADO: { color: "bg-green-500", borderColor: "border-green-500", label: "Proposta Aprovado" },
      PROPOSTA_REPROVADO: { color: "bg-red-500", borderColor: "border-red-500", label: "Proposta Reprovado" },
      FINALIZADO: { color: "bg-gray-500", borderColor: "border-gray-500", label: "Finalizado" },
      DEPOSITO: { color: "bg-cyan-500", borderColor: "border-cyan-500", label: "Depósito" },
    };
    return info[esteira] || { color: "bg-gray-400", borderColor: "border-gray-400", label: esteira?.replace(/_/g, " ") || "N/A" };
  };

  // Calcular tempo entre datas
  const calcularTempo = (dataInicio, dataFim) => {
    if (!dataInicio) return "N/A";
    const inicio = new Date(dataInicio);
    const fim = dataFim ? new Date(dataFim) : new Date();
    const diffMs = fim - inicio;
    
    const segundos = Math.floor((diffMs / 1000) % 60);
    const minutos = Math.floor((diffMs / (1000 * 60)) % 60);
    const horas = Math.floor((diffMs / (1000 * 60 * 60)) % 24);
    const dias = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    
    if (dias > 0) return `${dias}d ${horas}h ${minutos}m`;
    if (horas > 0) return `${horas}h ${minutos}m`;
    if (minutos > 0) return `${minutos}m ${segundos}s`;
    return `${segundos}s`;
  };

  // Formatar data para exibição
  const formatarData = (data) => {
    if (!data) return "-";
    return new Date(data).toLocaleString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    });
  };

  // Abrir modal de linha do tempo
  const abrirTimelineEsteira = (cliente) => {
    setTimelineCliente(cliente);
    setShowTimelineModal(true);
  };

  // Buscar contratos do cliente
  const buscarContratosCliente = async (cliente) => {
    setClienteContratos(cliente);
    setShowContratosModal(true);
    setLoadingContratos(true);
    
    try {
      const response = await axios.get(`${API}/contratos/cliente/${cliente.id}`);
      // Filtrar apenas contratos INTERNO (cadastrados pela empresa)
      const contratosInternos = (response.data.contratos || []).filter(c => c.tipo === "INTERNO");
      setContratosDoCliente(contratosInternos);
    } catch (error) {
      console.error("Erro ao buscar contratos:", error);
      toast.error("Erro ao buscar contratos do cliente");
      setContratosDoCliente([]);
    } finally {
      setLoadingContratos(false);
    }
  };

  // Agrupar contratos por situação
  const agruparContratosPorStatus = () => {
    const grupos = {
      EM_ANALISE: [],
      ATIVO: [],
      REPROVADO: [],
      ESTORNADO: [],
      OUTROS: []
    };
    
    contratosDoCliente.forEach(contrato => {
      const situacao = contrato.situacao;
      if (situacao === "EM_ANALISE") grupos.EM_ANALISE.push(contrato);
      else if (situacao === "ATIVO" || situacao === "APROVADO") grupos.ATIVO.push(contrato);
      else if (situacao === "REPROVADO" || situacao === "CANCELADO") grupos.REPROVADO.push(contrato);
      else if (situacao === "ESTORNADO") grupos.ESTORNADO.push(contrato);
      else grupos.OUTROS.push(contrato);
    });
    
    return grupos;
  };

  const totalPages = Math.ceil(total / perPage);

  // Estados para o modal de Solicitar Simulação
  const [showSimulacaoModal, setShowSimulacaoModal] = useState(false);
  const [buscaCliente, setBuscaCliente] = useState("");
  const [clientesEncontrados, setClientesEncontrados] = useState([]);
  const [clienteSelecionado, setClienteSelecionado] = useState(null);
  const [canalSolicitacao, setCanalSolicitacao] = useState("");
  const [servicoSolicitado, setServicoSolicitado] = useState("");
  const [buscandoCliente, setBuscandoCliente] = useState(false);
  const [registrandoSolicitacao, setRegistrandoSolicitacao] = useState(false);

  // Buscar cliente para simulação (usado no modal)
  const buscarClienteSimulacao = async () => {
    if (!buscaCliente.trim()) return;
    
    setBuscandoCliente(true);
    try {
      // Limpar CPF para verificar se é CPF
      const cpfLimpo = buscaCliente.trim().replace(/\D/g, "");
      
      let response;
      if (cpfLimpo.length === 11) {
        // Busca específica por CPF
        response = await axios.get(`${API}/clientes?cpf=${cpfLimpo}`);
      } else {
        // Busca geral
        response = await axios.get(`${API}/clientes?search=${encodeURIComponent(buscaCliente.trim())}`);
      }
      
      const clientes = response.data.clientes || [];
      setClientesEncontrados(clientes);
      
      // Se encontrou exatamente 1, já seleciona
      if (clientes.length === 1) {
        setClienteSelecionado(clientes[0]);
      } else {
        setClienteSelecionado(null);
      }
    } catch (error) {
      console.error("Erro na busca:", error);
      setClientesEncontrados([]);
    } finally {
      setBuscandoCliente(false);
    }
  };

  // Registrar solicitação de simulação
  const registrarSolicitacao = async () => {
    if (!clienteSelecionado || !canalSolicitacao || !servicoSolicitado) {
      return;
    }
    
    setRegistrandoSolicitacao(true);
    try {
      // Registrar a solicitação no histórico - o endpoint já atualiza o cliente
      const response = await axios.post(`${API}/solicitacoes`, {
        cliente_id: clienteSelecionado.id,
        cliente_nome: clienteSelecionado.nome,
        cliente_cpf: clienteSelecionado.cpf,
        cliente_instituicao: clienteSelecionado.primeira_instituicao,
        canal: canalSolicitacao,
        servico_solicitado: servicoSolicitado,
        instituicao: clienteSelecionado.primeira_instituicao,
        data_solicitacao: new Date().toISOString(),
        status: "CAPTACAO"
      });
      
      // Verificar se o cliente já estava em uma esteira ativa
      if (response.data.success === false) {
        toast.error(`${response.data.error}\n\nO cliente já está na tag "${response.data.esteira_atual}".`);
        return;
      }
      
      // Labels para serviço solicitado
      const servicoLabels = {
        "SIMULACAO_CONSIGNADO": "Simulação Consignado 💰",
        "ANDAMENTO_CONTRATO": "Andamento do Contrato 📑",
        "OUTROS_ASSUNTOS": "Outros Assuntos ✍🏽"
      };
      
      // Fechar modal e recarregar dados
      setShowSimulacaoModal(false);
      setClienteSelecionado(null);
      setBuscaCliente("");
      setCanalSolicitacao("");
      setServicoSolicitado("");
      setClientesEncontrados([]);
      fetchClientes();
      
      // Mostrar sucesso
      toast.success(`Solicitação registrada!\n\nCliente: ${clienteSelecionado.nome}\nCanal: ${canalSolicitacao}\nServiço: ${servicoLabels[servicoSolicitado] || servicoSolicitado}\nTag: Captação`);
      
    } catch (error) {
      console.error("Erro ao registrar solicitação:", error);
      toast.error("Erro ao registrar solicitação. Tente novamente.");
    } finally {
      setRegistrandoSolicitacao(false);
    }
  };

  // Formatar CPF enquanto digita
  const formatarCPFInput = (value) => {
    const numeros = value.replace(/\D/g, "").slice(0, 11);
    if (numeros.length <= 3) return numeros;
    if (numeros.length <= 6) return `${numeros.slice(0, 3)}.${numeros.slice(3)}`;
    if (numeros.length <= 9) return `${numeros.slice(0, 3)}.${numeros.slice(3, 6)}.${numeros.slice(6)}`;
    return `${numeros.slice(0, 3)}.${numeros.slice(3, 6)}.${numeros.slice(6, 9)}-${numeros.slice(9)}`;
  };

  // Buscar cliente e abrir modal
  const handleBuscarParaSimulacao = async () => {
    const termoBusca = buscaCliente.trim();
    
    // Se não tem termo de busca, apenas abre o modal vazio
    if (!termoBusca) {
      setClientesEncontrados([]);
      setClienteSelecionado(null);
      setShowSimulacaoModal(true);
      return;
    }
    
    setBuscandoCliente(true);
    setShowSimulacaoModal(true); // Abre o modal imediatamente mostrando loading
    
    try {
      // Limpar CPF para verificar se é CPF
      const cpfLimpo = termoBusca.replace(/\D/g, "");
      
      let response;
      if (cpfLimpo.length === 11) {
        // Busca específica por CPF
        response = await axios.get(`${API}/clientes?cpf=${cpfLimpo}`);
      } else {
        // Busca geral por nome, telefone, etc
        response = await axios.get(`${API}/clientes?search=${encodeURIComponent(termoBusca)}`);
      }
      
      const clientes = response.data.clientes || [];
      setClientesEncontrados(clientes);
      
      // Se encontrou exatamente 1 cliente, já seleciona automaticamente
      if (clientes.length === 1) {
        setClienteSelecionado(clientes[0]);
      } else {
        setClienteSelecionado(null);
      }
    } catch (error) {
      console.error("Erro na busca:", error);
      setClientesEncontrados([]);
      setClienteSelecionado(null);
    } finally {
      setBuscandoCliente(false);
    }
  };

  return (
    <div className="p-6 space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div className="flex items-center gap-4">
          <div>
            <h1 className="text-3xl font-bold text-slate-900" data-testid="clients-list-title">
              Gestão de Clientes
            </h1>
            <p className="text-muted-foreground mt-1">
              {total} cliente(s) encontrado(s)
            </p>
          </div>
          
          {/* Solicitar Simulação */}
          <div className="flex items-center gap-2 ml-4">
            <div className="flex items-center border rounded-lg overflow-hidden bg-white shadow-sm">
              <Select defaultValue="cpf">
                <SelectTrigger className="w-[80px] border-0 rounded-none focus:ring-0">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="cpf">CPF</SelectItem>
                </SelectContent>
              </Select>
              <Input
                placeholder="000.000.000-00"
                value={buscaCliente}
                onChange={(e) => setBuscaCliente(formatarCPFInput(e.target.value))}
                onKeyDown={(e) => e.key === "Enter" && handleBuscarParaSimulacao()}
                className="w-[150px] border-0 border-l rounded-none focus:ring-0"
              />
            </div>
            <Button 
              onClick={handleBuscarParaSimulacao}
              disabled={buscandoCliente}
              className="bg-red-500 hover:bg-red-600 text-white gap-2"
            >
              {buscandoCliente ? (
                <Loader2 className="h-4 w-4 animate-spin" />
              ) : (
                <FileSearch className="h-4 w-4" />
              )}
              SOLICITAR SIMULAÇÃO
            </Button>
          </div>
        </div>
        
        <div className="flex items-center gap-2">
          <Button variant="outline" onClick={fetchClientes} className="gap-2" data-testid="refresh-btn">
            <RefreshCw className="h-4 w-4" />
            Atualizar
          </Button>
          <Button variant="outline" className="gap-2" disabled>
            <Download className="h-4 w-4" />
            Exportar
          </Button>
          <Link to="/clientes/novo">
            <Button className="gap-2" data-testid="new-client-btn">
              <Plus className="h-4 w-4" />
              Novo Cliente
            </Button>
          </Link>
        </div>
      </div>

      {/* Filters */}
      <Card>
        <CardHeader className="pb-4">
          <CardTitle className="text-lg flex items-center gap-2">
            <Filter className="h-5 w-5" />
            Filtros
          </CardTitle>
        </CardHeader>
        <CardContent>
          {/* Filtro de Período */}
          <div className="flex items-center gap-2 mb-4">
            <Calendar className="h-4 w-4 text-gray-500" />
            <span className="text-sm font-medium text-gray-600">Período:</span>
            {[
              { value: "hoje", label: "Hoje" },
              { value: "semana", label: "Esta Semana" },
              { value: "mes", label: "Este Mês" },
              { value: "todos", label: "Todos" },
            ].map(p => (
              <Badge
                key={p.value}
                variant={periodo === p.value ? "default" : "outline"}
                className="cursor-pointer hover:opacity-80 transition-opacity"
                data-testid={`periodo-${p.value}`}
                onClick={() => { setPeriodo(p.value); setPage(1); }}
              >
                {p.label}
              </Badge>
            ))}
          </div>
          <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-5">
            <div className="lg:col-span-2">
              <div className="relative">
                <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
                <Input
                  placeholder="Buscar por nome, CPF, telefone, email..."
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                    setPage(1);
                  }}
                  className="pl-10"
                  data-testid="search-input"
                />
              </div>
            </div>
            <Select value={status} onValueChange={(v) => { setStatus(v); setPage(1); }}>
              <SelectTrigger data-testid="status-filter">
                <SelectValue placeholder="Status" />
              </SelectTrigger>
              <SelectContent>
                {statusOptions.map((opt) => (
                  <SelectItem key={opt.value} value={opt.value}>{opt.label}</SelectItem>
                ))}
              </SelectContent>
            </Select>
            <Select value={esteira} onValueChange={(v) => { setEsteira(v); setPage(1); }}>
              <SelectTrigger data-testid="esteira-filter">
                <SelectValue placeholder="Etapa" />
              </SelectTrigger>
              <SelectContent>
                {esteiraOptions.map((opt) => (
                  <SelectItem key={opt.value} value={opt.value}>{opt.label}</SelectItem>
                ))}
              </SelectContent>
            </Select>
            <Select value={classificacao} onValueChange={(v) => { setClassificacao(v); setPage(1); }}>
              <SelectTrigger data-testid="classificacao-filter">
                <SelectValue placeholder="Classificação" />
              </SelectTrigger>
              <SelectContent>
                {classificacaoOptions.map((opt) => (
                  <SelectItem key={opt.value} value={opt.value}>{opt.label}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </CardContent>
      </Card>

      {/* Filtros de Tags de Clientes */}
      <Card>
        <CardContent className="py-4">
          <div className="flex items-center justify-between">
            <div className="flex flex-wrap gap-2 items-center">
              <span className="text-sm font-medium text-slate-600 mr-2">Tags:</span>
              <Badge 
                variant={filtroTagCliente === "TODAS" ? "default" : "outline"}
                className="cursor-pointer hover:bg-slate-100"
                onClick={() => { setPage(1); setFiltroTagCliente("TODAS"); }}
              >
                Todos ({tagCountsTotal})
              </Badge>
              {tagsClientes.map(tag => (
                <Badge 
                  key={tag.id}
                  variant={filtroTagCliente === tag.id ? "default" : "outline"}
                  className="cursor-pointer hover:opacity-80 transition-opacity"
                  style={{ 
                    backgroundColor: filtroTagCliente === tag.id ? tag.cor : tag.bgCor,
                    color: filtroTagCliente === tag.id ? "white" : tag.cor,
                    borderColor: tag.cor
                  }}
                  onClick={() => { setPage(1); setFiltroTagCliente(filtroTagCliente === tag.id ? "TODAS" : tag.id); }}
                >
                  {tag.nome} ({tagCounts[tag.id] || 0})
                </Badge>
              ))}
            </div>
            <Button 
              variant="outline" 
              size="sm" 
              onClick={() => setShowConfigTagsClientes(true)}
              data-testid="btn-configurar-tags-clientes"
            >
              <Settings className="w-4 h-4 mr-1" />
              Configurar Tags
            </Button>
          </div>
        </CardContent>
      </Card>

      {/* Table */}
      <Card>
        <CardContent className="p-0">
          <div className="overflow-x-auto">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead className="w-[80px]">Código</TableHead>
                  <TableHead>Nome</TableHead>
                  <TableHead>Tag Cliente</TableHead>
                  <TableHead>Instituição</TableHead>
                  <TableHead>CPF</TableHead>
                  <TableHead>Telefone</TableHead>
                  <TableHead>Classificação</TableHead>
                  <TableHead>Etapa</TableHead>
                  <TableHead>Status</TableHead>
                  <TableHead className="text-right">Ações</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {loading ? (
                  Array(5).fill(0).map((_, i) => (
                    <TableRow key={i}>
                      {Array(9).fill(0).map((_, j) => (
                        <TableCell key={j}>
                          <div className="h-4 bg-slate-200 rounded animate-pulse"></div>
                        </TableCell>
                      ))}
                    </TableRow>
                  ))
                ) : clientes.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={9} className="h-32 text-center">
                      <div className="flex flex-col items-center justify-center text-muted-foreground">
                        <Search className="h-8 w-8 mb-2" />
                        <p>Nenhum cliente encontrado</p>
                        <Link to="/clientes/novo" className="mt-2">
                          <Button variant="outline" size="sm">Cadastrar novo cliente</Button>
                        </Link>
                      </div>
                    </TableCell>
                  </TableRow>
                ) : (
                  clientesFiltradosPorTag.map((cliente) => (
                    <TableRow key={cliente.id} data-testid={`client-row-${cliente.id}`}>
                      <TableCell className="font-mono text-sm">
                        <div className="flex flex-col leading-tight">
                          {cliente.empresa_nome && (
                            <span className="text-[10px] font-semibold text-red-600 uppercase tracking-wide" title="Empresa do cliente" data-testid={`cliente-empresa-${cliente.id}`}>
                              {cliente.empresa_nome}
                            </span>
                          )}
                          <span>#{cliente.codigo}</span>
                          {cliente.criado_por_nome && (
                            <span className="text-[9px] text-gray-500 mt-0.5 font-sans normal-case" title="Cadastrado por" data-testid={`cliente-criado-por-${cliente.id}`}>
                              por <strong>{cliente.criado_por_nome}</strong>
                            </span>
                          )}
                          {cliente.created_at && (
                            <span className="text-[9px] text-gray-400 font-sans normal-case" title="Data do cadastro">
                              {new Date(cliente.created_at).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", year: "2-digit", hour: "2-digit", minute: "2-digit" })}
                            </span>
                          )}
                        </div>
                      </TableCell>
                      <TableCell>
                        <Link to={`/clientes/${cliente.id}/editar`} className="flex items-center gap-3 hover:text-primary transition-colors">
                          <Avatar className="h-8 w-8">
                            <AvatarImage src={cliente.foto_url || ""} alt={cliente.nome} />
                            <AvatarFallback className="bg-primary/10 text-primary font-semibold text-sm">
                              {cliente.nome?.charAt(0)?.toUpperCase() || "?"}
                            </AvatarFallback>
                          </Avatar>
                          <div className="min-w-0">
                            <p className="font-medium truncate hover:underline flex items-center gap-2">
                              {cliente.nome}
                              {cliente._fonte === 'leads_base' && (
                                <span
                                  className="text-[9px] font-bold px-1.5 py-0.5 rounded bg-orange-100 text-orange-700 border border-orange-300 uppercase tracking-wide"
                                  title="Lead importado da Base — clique em 'Migrar p/ Externo' para virar cliente"
                                  data-testid={`lead-base-badge-${cliente.id}`}
                                >LEAD BASE</span>
                              )}
                            </p>
                            {cliente.apelido && (
                              <p className="text-xs text-muted-foreground">({cliente.apelido})</p>
                            )}
                          </div>
                        </Link>
                      </TableCell>
                      {/* Coluna de Tag */}
                      <TableCell>
                        <Popover>
                          <PopoverTrigger asChild>
                            <Button 
                              variant="outline" 
                              size="sm"
                              className="h-7 text-xs justify-between min-w-[120px]"
                              style={{
                                backgroundColor: tagsClientes.find(t => t.id === cliente.tag_gestao_id)?.bgCor || "#F9FAFB",
                                borderColor: tagsClientes.find(t => t.id === cliente.tag_gestao_id)?.cor || "#E5E7EB",
                                color: tagsClientes.find(t => t.id === cliente.tag_gestao_id)?.cor || "#6B7280"
                              }}
                            >
                              <span className="flex items-center gap-1 truncate">
                                <div 
                                  className="w-2 h-2 rounded-full flex-shrink-0"
                                  style={{ backgroundColor: tagsClientes.find(t => t.id === cliente.tag_gestao_id)?.cor || "#6B7280" }}
                                />
                                {cliente.tag_gestao_nome || "Selecionar"}
                              </span>
                              <ChevronDown className="w-3 h-3 ml-1 flex-shrink-0" />
                            </Button>
                          </PopoverTrigger>
                          <PopoverContent className="w-[180px] p-1" align="start">
                            {tagsClientes.map(tag => (
                              <button
                                key={tag.id}
                                className={cn(
                                  "w-full flex items-center gap-2 px-3 py-2 rounded text-sm hover:bg-slate-100 transition-colors",
                                  cliente.tag_gestao_id === tag.id && "bg-slate-100"
                                )}
                                onClick={() => mudarTagCliente(cliente.id, tag.id)}
                              >
                                <div 
                                  className="w-3 h-3 rounded-full"
                                  style={{ backgroundColor: tag.cor }}
                                />
                                <span style={{ color: tag.cor }}>{tag.nome}</span>
                                {cliente.tag_gestao_id === tag.id && (
                                  <Check className="w-4 h-4 ml-auto text-emerald-500" />
                                )}
                              </button>
                            ))}
                          </PopoverContent>
                        </Popover>
                      </TableCell>
                      <TableCell>
                        <span className="text-sm">
                          {typeof cliente.primeira_instituicao === 'object' 
                            ? (cliente.primeira_instituicao?.nome || cliente.beneficio?.instituicao || "-")
                            : (cliente.primeira_instituicao || cliente.beneficio?.instituicao || "-")}
                        </span>
                      </TableCell>
                      <TableCell className="font-mono text-sm">{formatCPF(cliente.cpf)}</TableCell>
                      <TableCell>
                        {cliente.telefones?.[0]?.numero || "-"}
                      </TableCell>
                      <TableCell>
                        <Badge variant="outline">{cliente.classificacao}</Badge>
                      </TableCell>
                      <TableCell>
                        <div 
                          className="cursor-pointer hover:bg-gray-50 rounded-lg p-1.5 transition-colors"
                          onClick={() => abrirTimelineEsteira(cliente)}
                          title="Clique para ver linha do tempo completa"
                          data-testid={`timeline-btn-${cliente.id}`}
                        >
                          <div className="flex items-center gap-2 mb-1">
                            {cliente.tag_gestao_nome ? (
                              <Badge
                                variant="outline"
                                className="font-medium text-xs"
                                style={{
                                  backgroundColor: tagsClientes.find(t => t.id === cliente.tag_gestao_id)?.bgCor || "#F9FAFB",
                                  borderColor: tagsClientes.find(t => t.id === cliente.tag_gestao_id)?.cor || "#E5E7EB",
                                  color: tagsClientes.find(t => t.id === cliente.tag_gestao_id)?.cor || "#6B7280"
                                }}
                              >
                                {cliente.tag_gestao_nome}
                              </Badge>
                            ) : (
                              getEsteiraBadge(cliente.esteira_atual)
                            )}
                            <History className="h-3.5 w-3.5 text-gray-400" />
                          </div>
                          <div className="text-[10px] space-y-0.5">
                            {(() => {
                              const historico = cliente.historico_tags || [];
                              const lastEntry = historico.length > 0 ? historico[historico.length - 1] : null;
                              const tempoAtual = lastEntry ? calcularTempo(lastEntry.data, null) : 
                                (cliente.created_at ? calcularTempo(cliente.created_at, null) : "N/A");
                              const totalTags = historico.length;
                              
                              return (
                                <>
                                  <div className="flex items-center gap-1 text-gray-500">
                                    <Clock className="h-3 w-3" />
                                    <span>Na tag: <span className="font-semibold text-gray-700">{tempoAtual}</span></span>
                                  </div>
                                  {totalTags > 1 && (
                                    <div className="flex items-center gap-1 text-gray-500">
                                      <ArrowRight className="h-3 w-3" />
                                      <span>Passou por <span className="font-semibold text-gray-700">{totalTags}</span> tag{totalTags > 1 ? 's' : ''}</span>
                                    </div>
                                  )}
                                </>
                              );
                            })()}
                          </div>
                        </div>
                      </TableCell>
                      <TableCell>{getStatusBadge(cliente)}</TableCell>
                      <TableCell>
                        <div className="flex items-center gap-2">
                          {cliente._fonte === 'leads_base' ? (
                            <>
                            <div className="flex flex-col items-center">
                              <span className="text-[10px] text-orange-700 font-medium mb-0.5">Migrar</span>
                              <Button
                                size="sm"
                                className="h-7 px-2 text-xs bg-orange-600 hover:bg-orange-700 text-white"
                                title="Criar cliente Externo a partir deste lead"
                                data-testid={`btn-migrar-lead-${cliente.id}`}
                                onClick={() => migrarLeadParaExterno(cliente)}
                              >
                                p/ Externo
                              </Button>
                            </div>
                            {/* Monitorar (também para leads da Base) */}
                            <div className="flex flex-col items-center">
                              <span className="text-[10px] text-green-600 font-medium mb-0.5">Monitorar</span>
                              <Link to={`/monitoramento-contratos?cliente_id=${cliente.id}`}>
                                <Button variant="ghost" size="icon" className="h-7 w-7 text-green-600 hover:text-green-700 hover:bg-green-50" title="Monitoramento" data-testid={`btn-monitorar-lead-${cliente.id}`}>
                                  <FileSearch className="h-4 w-4" />
                                </Button>
                              </Link>
                            </div>
                            </>
                          ) : (<>
                          {/* Contratos */}
                          <div className="flex flex-col items-center">
                            <span className="text-[10px] text-purple-600 font-medium mb-0.5">Contratos</span>
                            <Button 
                              variant="ghost" 
                              size="icon" 
                              className="h-7 w-7 text-purple-600 hover:text-purple-700 hover:bg-purple-50" 
                              title="Ver Contratos do Cliente"
                              data-testid={`btn-contratos-${cliente.id}`}
                              onClick={() => navigate(`/vendas?cpf=${encodeURIComponent(cliente.cpf || '')}`)}
                            >
                              <FileText className="h-4 w-4" />
                            </Button>
                          </div>
                          {/* Cadastrar */}
                          <div className="flex flex-col items-center">
                            <span className="text-[10px] text-teal-600 font-medium mb-0.5">Cadastrar</span>
                            <Link to={`/cadastro-contrato?cliente_id=${cliente.id}&cpf=${encodeURIComponent(cliente.cpf || '')}&nome=${encodeURIComponent(cliente.nome || '')}`}>
                              <Button 
                                variant="ghost" 
                                size="icon" 
                                className="h-7 w-7 text-teal-600 hover:text-teal-700 hover:bg-teal-50" 
                                title="Cadastrar Contrato"
                              >
                                <FilePlus2 className="h-4 w-4" />
                              </Button>
                            </Link>
                          </div>
                          {/* Monitorar */}
                          <div className="flex flex-col items-center">
                            <span className="text-[10px] text-green-600 font-medium mb-0.5">Monitorar</span>
                            <Link to={`/monitoramento-contratos?cliente_id=${cliente.id}`}>
                              <Button variant="ghost" size="icon" className="h-7 w-7 text-green-600 hover:text-green-700 hover:bg-green-50" title="Monitoramento">
                                <FileSearch className="h-4 w-4" />
                              </Button>
                            </Link>
                          </div>
                          {/* Editar */}
                          <div className="flex flex-col items-center">
                            <span className="text-[10px] text-amber-600 font-medium mb-0.5">Editar</span>
                            <Link to={`/clientes/${cliente.id}/editar`}>
                              <Button variant="ghost" size="icon" className="h-7 w-7 text-amber-600 hover:text-amber-700 hover:bg-amber-50" title="Editar">
                                <Edit className="h-4 w-4" />
                              </Button>
                            </Link>
                          </div>
                          {/* Excluir */}
                          <div className="flex flex-col items-center">
                            <span className="text-[10px] text-red-600 font-medium mb-0.5">Excluir</span>
                            <Button 
                              variant="ghost" 
                              size="icon" 
                              className="h-7 w-7 text-red-600 hover:text-red-700 hover:bg-red-50"
                              title="Excluir"
                              onClick={() => {
                                setClienteToDelete(cliente);
                                setDeleteDialogOpen(true);
                              }}
                            >
                              <Trash2 className="h-4 w-4" />
                            </Button>
                          </div>
                          </>)}
                        </div>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="flex items-center justify-between px-4 py-4 border-t">
              <p className="text-sm text-muted-foreground">
                Mostrando {((page - 1) * perPage) + 1} a {Math.min(page * perPage, total)} de {total}
              </p>
              <div className="flex items-center gap-2">
                <Button
                  variant="outline"
                  size="icon"
                  onClick={() => setPage(p => Math.max(1, p - 1))}
                  disabled={page === 1}
                  data-testid="prev-page-btn"
                >
                  <ChevronLeft className="h-4 w-4" />
                </Button>
                <span className="text-sm">
                  Página {page} de {totalPages}
                </span>
                <Button
                  variant="outline"
                  size="icon"
                  onClick={() => setPage(p => Math.min(totalPages, p + 1))}
                  disabled={page === totalPages}
                  data-testid="next-page-btn"
                >
                  <ChevronRight className="h-4 w-4" />
                </Button>
              </div>
            </div>
          )}
        </CardContent>
      </Card>

      {/* Delete Dialog */}
      <AlertDialog open={deleteDialogOpen} onOpenChange={setDeleteDialogOpen}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Confirmar Exclusão</AlertDialogTitle>
            <AlertDialogDescription>
              Tem certeza que deseja excluir o cliente <strong>{clienteToDelete?.nome}</strong>?
              Esta ação não pode ser desfeita.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancelar</AlertDialogCancel>
            <AlertDialogAction
              onClick={handleDelete}
              className="bg-red-600 hover:bg-red-700"
            >
              Excluir
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      {/* Modal de Contratos do Cliente */}
      <Dialog open={showContratosModal} onOpenChange={setShowContratosModal}>
        <DialogContent className="max-w-3xl max-h-[80vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <FileText className="h-5 w-5 text-purple-600" />
              Contratos do Cliente - INTERNO
            </DialogTitle>
            <DialogDescription>
              {clienteContratos?.nome} - CPF: {formatCPF(clienteContratos?.cpf || "")}
            </DialogDescription>
          </DialogHeader>
          
          {loadingContratos ? (
            <div className="flex items-center justify-center py-8">
              <RefreshCw className="h-6 w-6 animate-spin text-gray-400" />
              <span className="ml-2 text-gray-500">Carregando contratos...</span>
            </div>
          ) : contratosDoCliente.length === 0 ? (
            <div className="text-center py-8">
              <FileText className="h-12 w-12 mx-auto text-gray-300 mb-3" />
              <p className="text-gray-500">Nenhum contrato encontrado</p>
              <p className="text-sm text-gray-400">Este cliente ainda não possui contratos cadastrados</p>
            </div>
          ) : (
            <div className="space-y-4">
              {/* Em Análise */}
              {agruparContratosPorStatus().EM_ANALISE.length > 0 && (
                <div className="border rounded-lg overflow-hidden">
                  <div className="bg-yellow-50 px-4 py-2 border-b flex items-center gap-2">
                    <Clock className="h-4 w-4 text-yellow-600" />
                    <span className="font-semibold text-yellow-800">Em Análise ({agruparContratosPorStatus().EM_ANALISE.length})</span>
                  </div>
                  <div className="divide-y">
                    {agruparContratosPorStatus().EM_ANALISE.map(contrato => (
                      <div key={contrato.id} className="px-4 py-3 flex items-center justify-between">
                        <div>
                          <p className="font-mono text-sm font-medium">{contrato.numero_contrato}</p>
                          <p className="text-xs text-gray-500">{contrato.banco_nome} • {contrato.tipo_operacao}</p>
                        </div>
                        <div className="text-right">
                          <p className="font-semibold">R$ {(contrato.valor_liberado || contrato.valor_solicitado || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</p>
                          <Badge className="bg-yellow-100 text-yellow-800">Em Análise</Badge>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Aprovados/Ativos */}
              {agruparContratosPorStatus().ATIVO.length > 0 && (
                <div className="border rounded-lg overflow-hidden">
                  <div className="bg-green-50 px-4 py-2 border-b flex items-center gap-2">
                    <CheckCircle className="h-4 w-4 text-green-600" />
                    <span className="font-semibold text-green-800">Aprovados ({agruparContratosPorStatus().ATIVO.length})</span>
                  </div>
                  <div className="divide-y">
                    {agruparContratosPorStatus().ATIVO.map(contrato => (
                      <div key={contrato.id} className="px-4 py-3 flex items-center justify-between">
                        <div>
                          <p className="font-mono text-sm font-medium">{contrato.numero_contrato}</p>
                          <p className="text-xs text-gray-500">{contrato.banco_nome} • {contrato.tipo_operacao}</p>
                        </div>
                        <div className="text-right">
                          <p className="font-semibold">R$ {(contrato.valor_liberado || contrato.valor_solicitado || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</p>
                          <Badge className="bg-green-100 text-green-800">Aprovado</Badge>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Reprovados */}
              {agruparContratosPorStatus().REPROVADO.length > 0 && (
                <div className="border rounded-lg overflow-hidden">
                  <div className="bg-red-50 px-4 py-2 border-b flex items-center gap-2">
                    <XCircle className="h-4 w-4 text-red-600" />
                    <span className="font-semibold text-red-800">Reprovados ({agruparContratosPorStatus().REPROVADO.length})</span>
                  </div>
                  <div className="divide-y">
                    {agruparContratosPorStatus().REPROVADO.map(contrato => (
                      <div key={contrato.id} className="px-4 py-3 flex items-center justify-between">
                        <div>
                          <p className="font-mono text-sm font-medium">{contrato.numero_contrato}</p>
                          <p className="text-xs text-gray-500">{contrato.banco_nome} • {contrato.tipo_operacao}</p>
                          {contrato.motivo_reprovacao && (
                            <p className="text-xs text-red-600 mt-1">Motivo: {contrato.motivo_reprovacao}</p>
                          )}
                        </div>
                        <div className="text-right">
                          <p className="font-semibold">R$ {(contrato.valor_liberado || contrato.valor_solicitado || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</p>
                          <Badge className="bg-red-100 text-red-800">Reprovado</Badge>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Estornados */}
              {agruparContratosPorStatus().ESTORNADO.length > 0 && (
                <div className="border rounded-lg overflow-hidden">
                  <div className="bg-gray-50 px-4 py-2 border-b flex items-center gap-2">
                    <XCircle className="h-4 w-4 text-gray-600" />
                    <span className="font-semibold text-gray-800">Estornados ({agruparContratosPorStatus().ESTORNADO.length})</span>
                  </div>
                  <div className="divide-y">
                    {agruparContratosPorStatus().ESTORNADO.map(contrato => (
                      <div key={contrato.id} className="px-4 py-3 flex items-center justify-between">
                        <div>
                          <p className="font-mono text-sm font-medium">{contrato.numero_contrato}</p>
                          <p className="text-xs text-gray-500">{contrato.banco_nome} • {contrato.tipo_operacao}</p>
                          {contrato.motivo_estorno && (
                            <p className="text-xs text-gray-600 mt-1">Motivo: {contrato.motivo_estorno}</p>
                          )}
                        </div>
                        <div className="text-right">
                          <p className="font-semibold">R$ {(contrato.valor_liberado || contrato.valor_solicitado || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</p>
                          <Badge className="bg-gray-100 text-gray-800">Estornado</Badge>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Outros */}
              {agruparContratosPorStatus().OUTROS.length > 0 && (
                <div className="border rounded-lg overflow-hidden">
                  <div className="bg-blue-50 px-4 py-2 border-b flex items-center gap-2">
                    <FileText className="h-4 w-4 text-blue-600" />
                    <span className="font-semibold text-blue-800">Outros ({agruparContratosPorStatus().OUTROS.length})</span>
                  </div>
                  <div className="divide-y">
                    {agruparContratosPorStatus().OUTROS.map(contrato => (
                      <div key={contrato.id} className="px-4 py-3 flex items-center justify-between">
                        <div>
                          <p className="font-mono text-sm font-medium">{contrato.numero_contrato}</p>
                          <p className="text-xs text-gray-500">{contrato.banco_nome} • {contrato.tipo_operacao}</p>
                        </div>
                        <div className="text-right">
                          <p className="font-semibold">R$ {(contrato.valor_liberado || contrato.valor_solicitado || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</p>
                          <Badge className="bg-blue-100 text-blue-800">{contrato.situacao}</Badge>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Resumo */}
              <div className="bg-gray-50 rounded-lg p-4 mt-4">
                <h4 className="font-semibold text-gray-700 mb-2">Resumo</h4>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
                  <div>
                    <p className="text-2xl font-bold text-yellow-600">{agruparContratosPorStatus().EM_ANALISE.length}</p>
                    <p className="text-xs text-gray-500">Em Análise</p>
                  </div>
                  <div>
                    <p className="text-2xl font-bold text-green-600">{agruparContratosPorStatus().ATIVO.length}</p>
                    <p className="text-xs text-gray-500">Aprovados</p>
                  </div>
                  <div>
                    <p className="text-2xl font-bold text-red-600">{agruparContratosPorStatus().REPROVADO.length}</p>
                    <p className="text-xs text-gray-500">Reprovados</p>
                  </div>
                  <div>
                    <p className="text-2xl font-bold text-gray-600">{agruparContratosPorStatus().ESTORNADO.length}</p>
                    <p className="text-xs text-gray-500">Estornados</p>
                  </div>
                </div>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Modal de Linha do Tempo de Tags */}
      <TimelineTagsModal
        open={showTimelineModal}
        onOpenChange={setShowTimelineModal}
        entity={timelineCliente}
        tags={tagsClientes}
        mode="cliente"
      />

      {/* Modal de Solicitar Simulação */}
      <Dialog open={showSimulacaoModal} onOpenChange={setShowSimulacaoModal}>
        <DialogContent className="max-w-2xl">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-xl">
              <FileSearch className="h-6 w-6 text-red-600" />
              Solicitar Simulação / Análise
            </DialogTitle>
            <DialogDescription>
              Localize o cliente na base e registre a solicitação
            </DialogDescription>
          </DialogHeader>

          <div className="space-y-5 py-4">
            {/* Busca de Cliente */}
            {!clienteSelecionado ? (
              <div className="space-y-3">
                <Label className="text-sm font-medium">1. Localizar Cliente</Label>
                <div className="flex gap-2">
                  <div className="relative flex-1">
                    <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
                    <Input
                      placeholder="Digite CPF, Nome ou Telefone..."
                      className="pl-10"
                      value={buscaCliente}
                      onChange={(e) => setBuscaCliente(e.target.value)}
                      onKeyDown={(e) => e.key === "Enter" && buscarClienteSimulacao()}
                      autoFocus
                    />
                  </div>
                  <Button 
                    onClick={buscarClienteSimulacao}
                    disabled={buscandoCliente}
                    className="gap-2"
                  >
                    {buscandoCliente ? (
                      <Loader2 className="h-4 w-4 animate-spin" />
                    ) : (
                      <Search className="h-4 w-4" />
                    )}
                    Buscar
                  </Button>
                </div>

                {/* Lista de Clientes Encontrados */}
                {clientesEncontrados.length > 0 && (
                  <div className="border rounded-lg max-h-56 overflow-y-auto">
                    {clientesEncontrados.map((cliente) => (
                      <div
                        key={cliente.id}
                        onClick={() => setClienteSelecionado(cliente)}
                        className="flex items-center gap-3 p-3 cursor-pointer transition-colors border-b last:border-b-0 hover:bg-green-50"
                      >
                        <div className="h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center">
                          <span className="text-primary font-semibold">
                            {cliente.nome?.charAt(0)?.toUpperCase() || "?"}
                          </span>
                        </div>
                        <div className="flex-1">
                          <p className="font-medium">{cliente.nome}</p>
                          <p className="text-sm text-muted-foreground">
                            CPF: {cliente.cpf} | Tel: {cliente.telefone_1 || "N/A"}
                          </p>
                        </div>
                        <Badge variant="outline" className="bg-green-50 text-green-700 border-green-300">
                          Selecionar
                        </Badge>
                      </div>
                    ))}
                  </div>
                )}

                {clientesEncontrados.length === 0 && buscaCliente && !buscandoCliente && (
                  <p className="text-sm text-muted-foreground text-center py-4">
                    Nenhum cliente encontrado. Tente outro termo de busca.
                  </p>
                )}
              </div>
            ) : (
              <>
                {/* Cliente Selecionado */}
                <div className="p-4 bg-green-50 border border-green-200 rounded-lg">
                  <div className="flex items-center justify-between mb-3">
                    <div className="flex items-center gap-2">
                      <CheckCircle className="h-5 w-5 text-green-600" />
                      <span className="font-semibold text-green-800">Cliente Selecionado</span>
                    </div>
                    <Button 
                      variant="ghost" 
                      size="sm" 
                      onClick={() => {
                        setClienteSelecionado(null);
                        setCanalSolicitacao("");
                        setServicoSolicitado("");
                      }}
                      className="text-xs text-gray-500 hover:text-red-600"
                    >
                      Trocar cliente
                    </Button>
                  </div>
                  <div className="flex items-center gap-4">
                    <div className="h-12 w-12 rounded-full bg-green-200 flex items-center justify-center">
                      <span className="text-green-800 font-bold text-lg">
                        {clienteSelecionado.nome?.charAt(0)?.toUpperCase() || "?"}
                      </span>
                    </div>
                    <div>
                      <p className="font-semibold text-lg">{clienteSelecionado.nome}</p>
                      <p className="text-sm text-gray-600">
                        CPF: {clienteSelecionado.cpf} | Instituição: {typeof clienteSelecionado.primeira_instituicao === 'object' 
                          ? (clienteSelecionado.primeira_instituicao?.nome || "N/A")
                          : (clienteSelecionado.primeira_instituicao || "N/A")}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Canal de Solicitação - ÍCONES CLICÁVEIS */}
                <div className="space-y-3">
                  <Label className="text-sm font-medium">2. Por qual canal o cliente solicitou?</Label>
                  <div className="grid grid-cols-4 sm:grid-cols-6 gap-3">
                    {[
                      { id: "WHATSAPP", icon: MessageCircle, label: "WhatsApp", color: "bg-green-500 hover:bg-green-600" },
                      { id: "LIGAÇÃO CELULAR", icon: Phone, label: "Cel", color: "bg-blue-500 hover:bg-blue-600" },
                      { id: "LIGAÇÃO FIXO", icon: Phone, label: "Fixo", color: "bg-blue-600 hover:bg-blue-700" },
                      { id: "INSTAGRAM", icon: Instagram, label: "Instagram", color: "bg-pink-500 hover:bg-pink-600" },
                      { id: "FACEBOOK", icon: Facebook, label: "Facebook", color: "bg-indigo-600 hover:bg-indigo-700" },
                      { id: "E-MAIL MKT", icon: Mail, label: "E-mail", color: "bg-yellow-500 hover:bg-yellow-600" },
                      { id: "SMS MKT", icon: Megaphone, label: "SMS", color: "bg-purple-500 hover:bg-purple-600" },
                      { id: "PABX MKT", icon: Phone, label: "PABX", color: "bg-cyan-500 hover:bg-cyan-600" },
                      { id: "SITE", icon: Globe, label: "Site", color: "bg-teal-500 hover:bg-teal-600" },
                      { id: "INDICAÇÃO", icon: UserPlus, label: "Indicação", color: "bg-amber-500 hover:bg-amber-600" },
                      { id: "PRESENCIAL", icon: Store, label: "Loja", color: "bg-emerald-500 hover:bg-emerald-600" },
                      { id: "OUTROS", icon: AlertCircle, label: "Outros", color: "bg-gray-500 hover:bg-gray-600" },
                    ].map((canal) => {
                      const IconComp = canal.icon;
                      const isSelected = canalSolicitacao === canal.id;
                      return (
                        <button
                          key={canal.id}
                          type="button"
                          onClick={() => setCanalSolicitacao(canal.id)}
                          className={cn(
                            "flex flex-col items-center justify-center p-3 rounded-lg transition-all border-2",
                            isSelected 
                              ? `${canal.color} text-white border-transparent shadow-lg scale-105` 
                              : "bg-white hover:bg-gray-50 border-gray-200 hover:border-gray-300"
                          )}
                        >
                          <IconComp className={cn("h-6 w-6 mb-1", isSelected ? "text-white" : "text-gray-600")} />
                          <span className={cn("text-xs font-medium", isSelected ? "text-white" : "text-gray-600")}>
                            {canal.label}
                          </span>
                        </button>
                      );
                    })}
                  </div>
                </div>

                {/* Serviço Solicitado - PASSO 3 */}
                {canalSolicitacao && (
                  <div className="space-y-3">
                    <Label className="text-sm font-medium">3. Qual Serviço Solicitado?</Label>
                    <div className="grid grid-cols-3 gap-3">
                      {[
                        { id: "SIMULACAO_CONSIGNADO", label: "Simulação Consignado", emoji: "💰", color: "bg-green-500 hover:bg-green-600" },
                        { id: "ANDAMENTO_CONTRATO", label: "Andamento do Contrato", emoji: "📑", color: "bg-blue-500 hover:bg-blue-600" },
                        { id: "OUTROS_ASSUNTOS", label: "Outros Assuntos", emoji: "✍🏽", color: "bg-orange-500 hover:bg-orange-600" },
                      ].map((servico) => {
                        const isSelected = servicoSolicitado === servico.id;
                        return (
                          <button
                            key={servico.id}
                            type="button"
                            onClick={() => setServicoSolicitado(servico.id)}
                            className={cn(
                              "flex flex-col items-center justify-center p-4 rounded-lg transition-all border-2",
                              isSelected 
                                ? `${servico.color} text-white border-transparent shadow-lg scale-105` 
                                : "bg-white hover:bg-gray-50 border-gray-200 hover:border-gray-300"
                            )}
                          >
                            <span className="text-2xl mb-2">{servico.emoji}</span>
                            <span className={cn("text-xs font-medium text-center", isSelected ? "text-white" : "text-gray-600")}>
                              {servico.label}
                            </span>
                          </button>
                        );
                      })}
                    </div>
                  </div>
                )}

                {/* Informação sobre tag */}
                <div className="p-3 bg-blue-50 border border-blue-200 rounded-lg flex items-center gap-2">
                  <Building2 className="h-5 w-5 text-blue-600" />
                  <p className="text-sm text-blue-800">
                    O cliente será direcionado para a <strong>Tag CAPTAÇÃO</strong>
                  </p>
                </div>
              </>
            )}
          </div>

          <DialogFooter>
            <Button variant="outline" onClick={() => {
              setShowSimulacaoModal(false);
              setClienteSelecionado(null);
              setBuscaCliente("");
              setCanalSolicitacao("");
              setServicoSolicitado("");
              setClientesEncontrados([]);
            }}>
              Cancelar
            </Button>
            <Button 
              onClick={registrarSolicitacao}
              disabled={!clienteSelecionado || !canalSolicitacao || !servicoSolicitado || registrandoSolicitacao}
              className="gap-2 bg-red-600 hover:bg-red-700"
            >
              {registrandoSolicitacao ? (
                <>
                  <Loader2 className="h-4 w-4 animate-spin" />
                  Registrando...
                </>
              ) : (
                <>
                  <CheckCircle className="h-4 w-4" />
                  Registrar Solicitação
                </>
              )}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Modal de Configuração de Tags de Clientes */}
      <Dialog open={showConfigTagsClientes} onOpenChange={setShowConfigTagsClientes}>
        <DialogContent className="max-w-lg">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Tag className="w-5 h-5" />
              Configurar Tags de Clientes
            </DialogTitle>
          </DialogHeader>

          <div className="space-y-4">
            {/* Lista de Tags Existentes */}
            <div className="space-y-2">
              <Label>Tags Existentes</Label>
              <div className="space-y-2 max-h-[300px] overflow-y-auto">
                {tagsClientes.map(tag => (
                  <div 
                    key={tag.id}
                    className="flex items-center justify-between p-3 rounded-lg border"
                    style={{ backgroundColor: tag.bgCor, borderColor: tag.cor }}
                  >
                    {editandoTagCliente?.id === tag.id ? (
                      <div className="flex items-center gap-2 flex-1">
                        <Input
                          value={editandoTagCliente.nome}
                          onChange={(e) => setEditandoTagCliente({ ...editandoTagCliente, nome: e.target.value })}
                          className="h-8"
                        />
                        <Popover>
                          <PopoverTrigger asChild>
                            <Button variant="outline" size="sm" className="h-8 w-8 p-0">
                              <div 
                                className="w-4 h-4 rounded-full"
                                style={{ backgroundColor: editandoTagCliente.cor }}
                              />
                            </Button>
                          </PopoverTrigger>
                          <PopoverContent className="w-auto p-2">
                            <div className="grid grid-cols-4 gap-1">
                              {CORES_TAGS.map(corOpcao => (
                                <button
                                  key={corOpcao.cor}
                                  className={cn(
                                    "w-8 h-8 rounded-full border-2 transition-transform hover:scale-110",
                                    editandoTagCliente.cor === corOpcao.cor && "ring-2 ring-offset-2"
                                  )}
                                  style={{ backgroundColor: corOpcao.cor }}
                                  onClick={() => setEditandoTagCliente({ 
                                    ...editandoTagCliente, 
                                    cor: corOpcao.cor, 
                                    bgCor: corOpcao.bgCor 
                                  })}
                                />
                              ))}
                            </div>
                          </PopoverContent>
                        </Popover>
                        <Button size="sm" onClick={atualizarTagCliente} disabled={salvandoTagCliente}>
                          <Check className="w-4 h-4" />
                        </Button>
                        <Button size="sm" variant="ghost" onClick={() => setEditandoTagCliente(null)}>
                          <X className="w-4 h-4" />
                        </Button>
                      </div>
                    ) : (
                      <>
                        <div className="flex items-center gap-2">
                          <div 
                            className="w-4 h-4 rounded-full"
                            style={{ backgroundColor: tag.cor }}
                          />
                          <span style={{ color: tag.cor }} className="font-medium">
                            {tag.nome}
                          </span>
                          <Badge variant="outline" className="text-xs">
                            {contadorPorTagCliente[tag.id] || 0} clientes
                          </Badge>
                        </div>
                        <div className="flex items-center gap-1">
                          <Button 
                            variant="ghost" 
                            size="icon"
                            className="h-8 w-8"
                            onClick={() => setEditandoTagCliente({ ...tag })}
                          >
                            <Edit className="w-4 h-4" />
                          </Button>
                          <Button 
                            variant="ghost" 
                            size="icon"
                            className="h-8 w-8 text-red-500 hover:text-red-600"
                            onClick={() => excluirTagCliente(tag.id)}
                          >
                            <Trash2 className="w-4 h-4" />
                          </Button>
                        </div>
                      </>
                    )}
                  </div>
                ))}
              </div>
            </div>

            {/* Adicionar Nova Tag */}
            <div className="space-y-2 pt-4 border-t">
              <Label>Adicionar Nova Tag</Label>
              <div className="flex items-center gap-2">
                <Input
                  placeholder="Nome da tag..."
                  value={novaTagCliente.nome}
                  onChange={(e) => setNovaTagCliente({ ...novaTagCliente, nome: e.target.value })}
                  className="flex-1"
                />
                <Popover>
                  <PopoverTrigger asChild>
                    <Button variant="outline" className="w-10 h-10 p-0">
                      <div 
                        className="w-5 h-5 rounded-full"
                        style={{ backgroundColor: novaTagCliente.cor }}
                      />
                    </Button>
                  </PopoverTrigger>
                  <PopoverContent className="w-auto p-2">
                    <div className="grid grid-cols-4 gap-1">
                      {CORES_TAGS.map(corOpcao => (
                        <button
                          key={corOpcao.cor}
                          className={cn(
                            "w-8 h-8 rounded-full border-2 transition-transform hover:scale-110",
                            novaTagCliente.cor === corOpcao.cor && "ring-2 ring-offset-2"
                          )}
                          style={{ backgroundColor: corOpcao.cor }}
                          onClick={() => setNovaTagCliente({ 
                            ...novaTagCliente, 
                            cor: corOpcao.cor, 
                            bgCor: corOpcao.bgCor 
                          })}
                        />
                      ))}
                    </div>
                  </PopoverContent>
                </Popover>
                <Button onClick={criarTagCliente} disabled={salvandoTagCliente || !novaTagCliente.nome.trim()}>
                  <Plus className="w-4 h-4 mr-1" />
                  Adicionar
                </Button>
              </div>
            </div>
          </div>

          <DialogFooter>
            <Button variant="outline" onClick={() => setShowConfigTagsClientes(false)}>
              Fechar
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
